<main>
    <article class="application-menu">
        @for (app of apps; track app) {
  <a  class="application-menu__app" [href]="app.url" target="_blank" [style.backgroundColor]="app.color">
            

            @if (app.image) {
<img [src]="app.image" [alt]="app.name">
}
            <h5>{{ app.name }}</h5>
        </a>
}
    </article>
</main>